<template>
  <div>
    <b-row class="mb-3">
      <b-col>
        <h5>Access Scopes</h5>
        <small class="text-muted">Configure entity read/write permissions for this connector</small>
      </b-col>
      <b-col cols="auto">
        <b-button variant="primary" size="sm" :disabled="saving" @click="saveScopes">
          <b-spinner v-if="saving" small class="mr-1" />
          Save
        </b-button>
      </b-col>
    </b-row>

    <div v-if="loading" class="text-center py-3">
      <b-spinner variant="primary" />
    </div>

    <b-table
      v-else
      :items="scopeRows"
      :fields="fields"
      responsive
      bordered
      small
    >
      <template #cell(can_read)="{ item }">
        <b-form-checkbox v-model="item.can_read" />
      </template>

      <template #cell(can_write)="{ item }">
        <b-form-checkbox v-model="item.can_write" />
      </template>

      <template #cell(entity_type)="{ item }">
        <strong>{{ item.entity_type }}</strong>
      </template>

      <template #cell(allowed_fields)="{ item }">
        <b-form-tags
          v-model="item.allowed_fields"
          placeholder="Add field"
          tag-variant="info"
          size="sm"
          separator=" ,;"
        />
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  props: {
    connectorId: { type: Number, required: true },
  },
  data() {
    return {
      loading: false,
      saving: false,
      scopeRows: [],
      fields: [
        { key: 'entity_type', label: 'Entity' },
        { key: 'can_read', label: 'Read' },
        { key: 'can_write', label: 'Write' },
        { key: 'allowed_fields', label: 'Allowed Fields' },
      ],
    }
  },
  async mounted() {
    this.loading = true
    try {
      await Promise.all([
        this.$store.dispatch('appConnector/fetchScopes', this.connectorId),
        this.$store.dispatch('appConnector/fetchAvailableEntities'),
      ])

      const availableEntities = this.$store.state.appConnector.availableEntities
      const existingScopes = this.$store.state.appConnector.scopes

      this.scopeRows = (Array.isArray(availableEntities) ? availableEntities : Object.keys(availableEntities || {})).map(entity => {
        const entityKey = typeof entity === 'string' ? entity : entity.entity_type
        const existing = (existingScopes || []).find(s => s.entity_type === entityKey) || {}
        return {
          entity_type: entityKey,
          can_read: !!existing.can_read,
          can_write: !!existing.can_write,
          allowed_fields: existing.allowed_fields || [],
        }
      })
    } finally {
      this.loading = false
    }
  },
  methods: {
    async saveScopes() {
      this.saving = true
      try {
        await this.$store.dispatch('appConnector/updateScopes', {
          connectorId: this.connectorId,
          scopes: this.scopeRows,
        })
      } finally {
        this.saving = false
      }
    },
  },
}
</script>
